import { el } from "../lib/dom.js";
import { icon } from "../lib/icon.js";

/**
 * The security-token code field (UX spec v3 §6.5, `.code`): one real field,
 * numeric keyboard, one-time-code autofill, paste allowed. Digits only, six at
 * most, grouped "482 913" as they are typed. A wrong code puts a ring on the
 * field and the bank's own sentence under it as an alert; editing clears both.
 */
let seq = 0;

export class CodeEntry {
  readonly element: HTMLElement;
  readonly input: HTMLInputElement;
  #err: HTMLElement | undefined;

  constructor(onChange: (digits: string) => void) {
    seq += 1;
    const id = `code-lbl-${String(seq)}`;
    this.input = el("input", {
      class: "box empty",
      type: "text",
      inputMode: "numeric",
      autocomplete: "one-time-code",
      placeholder: "6 digits",
      maxLength: 7,
      aria: { labelledby: id },
    });
    this.input.addEventListener("input", () => {
      const digits = this.input.value.replace(/\D/g, "").slice(0, 6);
      this.input.value = digits.length > 3 ? `${digits.slice(0, 3)} ${digits.slice(3)}` : digits;
      this.input.classList.toggle("empty", digits === "");
      this.bad(null);
      onChange(digits);
    });
    this.element = el("div", { class: "code" }, [el("label", { id }, ["Code from your security token"]), this.input]);
  }

  get digits(): string {
    return this.input.value.replace(/\D/g, "");
  }

  /** A refused code: the ring and the bank's sentence; `null` clears them. */
  bad(message: string | null): void {
    this.#err?.remove();
    this.#err = undefined;
    this.input.classList.toggle("bad", message !== null);
    if (message === null) {
      this.input.removeAttribute("aria-invalid");
      return;
    }
    this.input.setAttribute("aria-invalid", "true");
    this.#err = el("div", { class: "err", role: "alert" }, [icon("i-alert"), el("span", {}, [message])]);
    this.element.appendChild(this.#err);
  }

  disabled(on: boolean): void {
    this.input.readOnly = on;
  }
}
